export default "/images/dansk_boligforsikring.png?f6f687c4f356da162c2d3069f6ee7903";